<template>
    <section class="summary" id="summary">
        <div class="summary__container container">
            <StepBar />
            <StepLink :step="previousStep" />
            <h3 class="title">Your Summary</h3>
            <!-- <SignIn /> -->
            <div class="summary__flex">
                <div class="card summary__card">
                    <div class="card__inner">
                        <template v-if="showAuthenticatedForm">
                            <div class="login__logged-in">
                                <form @submit.prevent="submitBookingDetails" id="logged-in" ref="form" method="post" class="material-form details-form summary__form" data-form-name="Online Service Booking - Your Details" style="position: relative;">
                                    <ul class="validation-error__ul ul__no-bullet" v-if="newlyRegistered">
                                        <li class="validation-error__li validation-error--success">Your account has been created successfully</li>
                                    </ul>
                                    <div class="form-grid form-grid--xs-1-column">
                                        <h3 class="card__heading">Your details:</h3>
                                        <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                                            <title-input :readonly="true" />
                                        </div>
                                        <div class="form-grid__col form-grid__col--xs-full-width">
                                            <first-name :readonly="true" />
                                        </div>
                                        <div class="form-grid__col form-grid__col--xs-full-width">
                                            <last-name :readonly="true" />
                                        </div>
                                        <div class="form-grid__col form-grid__col--xs-full-width">
                                            <email :readonly="true" />
                                        </div>
                                        <div class="form-grid__col form-grid__col--xs-full-width">
                                            <telephone :inputNullable="false" inputValidateMessage="Please enter a telephone number" />
                                        </div>
                                        <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                                            <privacy />
                                        </div>
                                        <button type="submit" class="btn btn--primary btn--full-width   summary__button summary__button-mobile">Continue</button>
                                    </div>
                                </form>
                            </div>
                        </template>
                        <!-- if not logged in  -->
                        <template v-else>
                            <SignInOrGuestToggle :guest="guest" @toggle-guest="handleToggleGuest"> </SignInOrGuestToggle>
                            <!-- log in as guest -->
                            <template v-if="showGuestForm">
                                <form @submit.prevent="submitBookingDetails" id="guest" ref="form" method="post" class="material-form details-form summary__form" data-form-name="Online Service Booking - Your Details" style="position: relative;">
                                    <div class="form-grid form-grid--xs-1-column">
                                        <h3 class="card__heading">Please fill out your details below:</h3>
                                        <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                                            <title-input />
                                        </div>
                                        <div class="form-grid__col form-grid__col--xs-full-width">
                                            <first-name />
                                        </div>
                                        <div class="form-grid__col form-grid__col--xs-full-width">
                                            <last-name />
                                        </div>
                                        <div class="form-grid__col form-grid__col--xs-full-width">
                                            <email />
                                        </div>
                                        <div class="form-grid__col form-grid__col--xs-full-width">
                                            <telephone :inputNullable="false" inputValidateMessage="Please enter a telephone number" />
                                        </div>
                                        <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                                            <privacy />
                                        </div>
                                        <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                                            <create-account @updateForm="updateValidatableElements" formType="osb" />
                                        </div>
                                        <button type="submit" class="btn btn--primary btn--full-width  summary__button summary__button-mobile">Continue</button>
                                    </div>
                                </form>
                            </template>
                            <!-- log in screen -->
                            <template v-else>
                                <Login></Login>
                            </template>
                        </template>
                    </div>
                </div>
                <div class="summary__booking-overview">
                    <BookingOverview />
                </div>
                <template v-if="guest === true || authenticated === true">
                    <button type="button" class="btn btn--primary btn--full-width  summary__button summary__button-desktop" @click.prevent="submitBookingDetails">
                        <span class="find-my-car__used-btn-txt">Continue</span>
                    </button>
                </template>
            </div>
        </div>
    </section>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import { BookingOverview, LoadingSpinner, StepBar, StepLink } from "../";
import TitleInput from "../../../core/components/Forms/Title.vue";
import FirstName from "../../../core/components/Forms/FirstName.vue";
import LastName from "../../../core/components/Forms/LastName.vue";
import Email from "../../../core/components/Forms/Email.vue";
import Telephone from "../../../core/components/Forms/Telephone.vue";
import CreateAccount from "../../../core/components/Forms/CreateAccount.vue";
import SignInOrGuestToggle from "../../../core/components/Auth/SignInOrGuestToggle.vue";
import Login from "../../../core/components/Auth/Login.vue";

import Privacy from "../Privacy.vue";
import { customEvent, generateLeadEvent } from '../../../modules/tracking/AnalyticsEvents';

export default {
    components: {
        LoadingSpinner,
        SignInOrGuestToggle,
        Login,
        CreateAccount,
        BookingOverview,
        StepBar,
        StepLink,
        TitleInput,
        FirstName,
        LastName,
        Email,
        Telephone,
        Privacy,
    },

    data() {
        return {
            validator: false,
            guest: null,
            newlyRegistered: false,
            submitting: false,
        };
    },

    watch: {
        showAuthenticatedForm(val) {
            if (val) {
                this.$nextTick(function () {
                    this.validator = new ContactFormValidator({
                        element: this.$refs['form'],
                        vueForm: true,
                        redesign: true,
                    });
                });
            }
        },
        showGuestForm(val) {
            if (val) {
                this.$nextTick(function () {
                    this.validator = new ContactFormValidator({
                        element: this.$refs['form'],
                        vueForm: true,
                        redesign: true,
                    });
                });
            }
        },
    },

    computed: {
        ...mapState("OSB", ["selectedOptions", "pricingData", "selectedVehicle", "otherSelected", "nonFranchiseVehicle", "carNotFound", "brand", "customerAddress", "bookingId", "loginUrl"]),
        ...mapState("Auth", ['authenticated', 'vehicleRegistered']),
        ...mapState("Dealers", ["selectedDealer"]),
        ...mapGetters("OSB", ["bookingDetailsFormatted", "vehicleDetailsFormatted", "selectedOptionsArray", "subTotal"]),

        previousStep() {
            if (this.pricingData.additional_services.length == 0) {
                // Service Options
                return 5;
            }
            // Additional Services
            return 6;
        },

        showAuthenticatedForm() {
            if (this.authenticated === true && ((this.newlyRegistered && !this.submitting) || (!this.newlyRegistered))) {
                return true;
            }
            return false;
        },

        showGuestForm() {
            if (this.guest === true || (this.authenticated && this.newlyRegistered && this.submitting)) {
                return true;
            }
            return false;
        }
    },

    methods: {
        ...mapMutations("OSB", ['incrementStep']),
        ...mapMutations("Auth", ['setHasAccount', 'setVehicleAdded', 'setAuthenticated']),

        updateValidatableElements() {
            this.$nextTick(function () {
                this.validator.updateValidatableElements();
            })
        },

        handleToggleGuest(guest) {
            this.guest = guest;
            this.$nextTick(function () {
                this.validator = new ContactFormValidator({
                    element: this.$refs['form'],
                    vueForm: true,
                    redesign: true,
                });
            })
        },

        createAccount(formData) {
            this.validator.preventInput();
            this.submitting = true;
            axios
                .post("/api/register", formData)
                .then(response => {
                    this.setVehicleAdded(response.data.vehicle_added)
                    this.setHasAccount(response.data.has_account)
                    if (response.data.has_account == true && response.data.success == true) {
                        this.setAuthenticated(true);
                        this.newlyRegistered = true;
                        this.guest = false;
                    }
                    this.createBooking(formData);
                    return;
                })
                .catch((error) => {
                    this.validator.errorResponse(error);
                    console.error(error);
                    // If we ended up authenticated after registering, then toggle us to the authenticated method
                    if (this.authenticated) {
                        this.handleToggleGuest(false);
                        this.$nextTick(function () {
                            this.validator.errorResponse(error);
                            this.submitting = false;
                        });
                    } else {
                        this.submitting = false;
                    }
                    return;
                });
        },

        createBooking(formData) {
            formData.set("booking-id", this.bookingId);
            formData.set("brand", this.brand !== "" ? this.brand : window.brand);
            formData.set("booking-details", JSON.stringify(this.bookingDetailsFormatted));
            formData.set("selected-options", JSON.stringify(this.selectedOptionsArray));
            formData.set("service-name", this.pricingData.service_pricing.name);
            formData.set("sub-total", this.subTotal);
            formData.set("location", this.customerAddress || "");
            this.validator.preventInput();
            this.submitting = true;
            axios
                .post("/api/osb/submit", formData)
                .then((response) => {
                    customEvent('OSB', 'Click', 'booking confirmed');
                    generateLeadEvent('osb_booking');
                    this.validator.allowInput();
                    this.incrementStep();
                    this.scrollToTop();
                    this.setVehicleAdded(response.data.vehicle_added)
                    this.setHasAccount(response.data.has_account)
                    this.submitting = true;
                    // this.validator.errorResponse(error);
                    // console.error(error);
                    return;
                })
                .catch((error) => {
                    this.validator.errorResponse(error);
                    console.error(error);

                    // If we ended up authenticated after registering, then toggle us to the authenticated method
                    if (this.authenticated) {
                        this.handleToggleGuest(false);
                        this.$nextTick(function () {
                            this.validator.errorResponse(error);
                            this.submitting = false;
                        });
                    } else {
                        this.submitting = true;
                    }
                });
        },

        async submitBookingDetails() {
            let formData = new FormData(this.$refs['form']);
            this.validator.errorResponse();
            if (!await this.validator.isValid()) {
                this.validator.scrollToFirstError();
                return;
            }

            formData.set("location-id", this.selectedDealer.id);
            formData.set("vehicle", JSON.stringify(this.vehicleDetailsFormatted));

            if (formData.get("create-account") == "true") {
                // Create an account and then booking
                this.createAccount(formData)
            } else {
                // create just Booking
                this.createBooking(formData)
            }
        },

        scrollToTop() {
            window.scrollTo(0, 0);
        },
    },

    mounted() {
        this.validator = new ContactFormValidator({
            element: this.$refs['form'],
            vueForm: true,
            redesign: true,
        });
        if (this.vehicleRegistered === true || this.authenticated) {
            this.guest = false
        } else {
            this.guest = true
        }
    },
};
</script>

<style lang="scss" scoped>
@import "../../../../sass/used/search-results/login-modal";
// @import "./search-results/login-modal";

.active {
    border: 1px solid #0093d6 !important;
    background-color: #ecf9ff;
    color: #0093d6;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/online-service-booking/components/Steps/YourSummary.vue